import type { ReactNode } from 'react';
import TextContentSep from '../common/TextContentSep';

export type SampleFactRowProps = {
  label: string;
  labelTitle?: string;
  children: ReactNode;
};

/** th/td の textContent 食い込み防止（sep は末尾。先頭に置くと見出しが `· ラベル` になる） */
export default function SampleFactRow({ label, labelTitle, children }: SampleFactRowProps) {
  return (
    <tr>
      <th title={labelTitle}>
        {label}
        <TextContentSep />
      </th>
      <td>{children}</td>
    </tr>
  );
}
